module.exports = __webpack_public_path__ + "static/img/no-goods.922e7476.png";